import type { EventModel } from './types';

/** Condition ids of the markets that can still trade, the ones worth streaming. */
export function openMarketIds(event: EventModel | null): string[] {
    if (!event) return [];
    return event.outcomes.flatMap(outcome =>
        outcome.quotes.filter(q => !q.closed).map(q => q.market.marketId)
    );
}

/**
 * Lays streamed YES probabilities over the fetched ones and marks those
 * quotes live. Returns the same object when nothing changes, so nothing
 * downstream re-renders.
 */
export function withLiveProbabilities(
    event: EventModel,
    live: ReadonlyMap<string, number>
): EventModel {
    if (live.size === 0) return event;
    let changed = false;
    const outcomes = event.outcomes.map(outcome => {
        let touched = false;
        const quotes = outcome.quotes.map(quote => {
            const probability = quote.closed
                ? undefined
                : live.get(quote.market.marketId);
            if (
                probability === undefined ||
                (quote.live && probability === quote.probability)
            ) {
                return quote;
            }
            touched = true;
            return { ...quote, probability, live: true };
        });
        if (!touched) return outcome;
        changed = true;
        return { ...outcome, quotes };
    });
    return changed ? { ...event, outcomes } : event;
}
